module.exports = __webpack_public_path__ + "static/media/warehouse-inside.442cd536.jpeg";